import { render, staticRenderFns } from "./button-blue.vue?vue&type=template&id=21af62b4"
import script from "./button-blue.vue?vue&type=script&lang=js"
export * from "./button-blue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports